var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoImage130(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h130v130H0V0Z",
    fill: "#F9FAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4 69.28h-5.9V53.6a.6.6 0 0 0-.6-.6H53.6a.6.6 0 0 0-.6.6v19.62A3.86 3.86 0 0 0 56.85 77h16.3A3.86 3.86 0 0 0 77 73.14v-3.26a.6.6 0 0 0-.6-.6Zm-22.2 3.86V54.2h15.1v15.08h-9.2a.6.6 0 0 0-.6.6v3.26a2.66 2.66 0 0 1-2.65 2.66 2.66 2.66 0 0 1-2.65-2.66Zm18.95 2.66H59.62a3.86 3.86 0 0 0 1.07-2.66v-2.66H75.8v2.66a2.66 2.66 0 0 1-2.65 2.66Z",
    fill: "#092F54",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3 58.07h8.91a.6.6 0 1 0 0-1.2H57.3a.6.6 0 1 0 0 1.2Zm0 6.64h7.1a.6.6 0 1 0 0-1.2h-7.1a.6.6 0 1 0 0 1.2Zm0-3.37h8.91a.6.6 0 1 0 0-1.2H57.3a.6.6 0 1 0 0 1.2Z",
    fill: "#092F54",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage130);
export default __webpack_public_path__ + "static/media/no-image-130.4f245b312ef3a9586a5a239fb27e8bfa.svg";
export { ForwardRef as ReactComponent };